import { format } from 'date-fns'

import { api_gateway } from '../../conexoes/api'
import { requestResolver } from '../../utils/requestResolver'

export const DashboardsService = {
  //#region Portadoras
  getConsumoPortadoras: (tipo) => {
    const horasPorTipo = {
      '24h': 24 * 1,
      '2d': 24 * 2,
      '3d': 24 * 3,
      '4d': 24 * 4,
      '5d': 24 * 5,
      '6d': 24 * 6,
      '7d': 24 * 7
    }

    let params = `hours=${horasPorTipo[tipo]}`
    return requestResolver(
      api_gateway.get(
        `api/v2/dashboards/carrier/history/consumption?${params}&network=null`
      )
    )
  },
  getHistoricoPortadoras: (tipo, periodo) => {
    const horasPorTipo = {
      '24h': 24 * 1,
      '48h': 24 * 2,
      '7d': 24 * 7,
      '15d': 24 * 15,
      '30d': 24 * 30
    }

    let params = ''

    if (tipo === 'periodo' && periodo.start && periodo.stop) {
      const formattedStart = format(new Date(periodo.start), 'yyyy-MM-dd')
      const formattedEnd = format(new Date(periodo.stop), 'yyyy-MM-dd')

      params = `start=${formattedStart}&stop=${formattedEnd}`
    } else {
      if (tipo === 'periodo') return

      params = `hours=${horasPorTipo[tipo]}`
    }

    return requestResolver(
      api_gateway.get(
        `api/v2/dashboards/carrier/history/conections?${params}&network=null`
      )
    )
  }
  //#endregion GET
}
